import { axiosInstance } from '../../api/api';
import * as ActionTypes from '../actionTypes';

export const fetchReceiveDetails = () => (dispatch) => {
	axiosInstance
		.get('/station/receive-details')
		.then(({ data }) => {
			if (data?.receiveTs) {
				dispatch(updateReceiveTs(data.receiveTs));
			}
		})
		.catch(() => {
			// Silently fail — banner just won't update if this call fails
		});
};

export const updateReceiveTs = (receiveTs) => ({
	type: ActionTypes.UPDATE_RECEIVE_TS,
	payload: { receiveTs },
});

export const clearReceiveTs = () => ({
	type: ActionTypes.UPDATE_RECEIVE_TS,
	payload: { receiveTs: null },
});
